import React, { useState, useEffect } from "react";
 
const WhatsAppChatButton = ({ 
  phoneNumber = "+12035016039", // Updated number with US country code
  message = "Hi Litax" 
}) => {
  const [visible, setVisible] = useState(true);
  const encodedMessage = encodeURIComponent(message);
 
  // Optional: toggle visibility like ScrollTop
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 200) { // adjust scroll threshold
        setVisible(true);
      } else {
        setVisible(true); // always visible
      }
    };
 
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);
 
  if (!visible) return null;
 
  return (
<div style={styles.container}>
<a
        href={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`}
        target="_blank"
        rel="noopener noreferrer"
>
<img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="WhatsApp Chat"
          style={styles.icon}
        />
</a>
</div>
  );
};
 
const styles = {
  container: {
    position: "fixed",
    bottom: "100px", // distance from bottom
    right: "20px",   // distance from right
    backgroundColor: "#25d366",
    borderRadius: "50%",
    width: "50px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
    zIndex: 9999,  // on top
    cursor: "pointer",
    transition: "transform 0.3s",
    ":hover": {
      transform: "scale(1.1)"
    }
  },
  icon: {
    width: "30px",
    height: "30px",
  },
};
 
export default WhatsAppChatButton;